import { IonButtons, IonGrid,  IonContent, IonHeader,  IonMenuButton, IonPage, IonRow, IonText, IonTitle, IonToolbar } from '@ionic/react';

const Abrev = (props) => {

    return (
        <>{(props.lang === 'ES') ?
                <IonPage>
                        <IonToolbar>
                            <IonButtons slot="start">
                                <IonMenuButton />
                            </IonButtons>
                            <IonTitle  className='headertitle' style={{ fontSize: "24"}}>Abreviaturas</IonTitle>
                        </IonToolbar>
                    <IonContent fullscreen className="IonPadding">
                        <IonGrid className="paddingh20 textblack  ion-padding-start ion-padding-end extra-padding ion-padding-bottom ion-margin-bottom">
                            <IonRow className="mt2  mx2 mb1 "><IonText>ARAII: Antagonistas de los receptores de la Angiotensina II</IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>ARM: Antagonistas de los receptores de mineralocorticoides</IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>BB: Betabloqueantes </IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>DIU: Diur&eacute;ticos de asa </IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>FC: Frecuencia Cardiaca </IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>FE: Fracci&oacute;n de Eyecci&oacute;n</IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>IC: Insuficiencia Cardiaca </IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>IECA: Inhibidores de la enzima convertidora de la Angiotensina</IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>INRA: Inhibidores de la neprilisina y del receptor de Angiotensina II </IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>iSGLT2: Inhibidores del cotransportador de sodio-glucosa de tipo 2</IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>K+: Potasio</IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>TAS: Tensi&oacute;n arterial sist&oacute;lica</IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>TFG: Tasa de filtrado glomerular</IonText></IonRow>
                        </IonGrid>
                    </IonContent>
                </IonPage> 
                :
                <IonPage>
                        <IonToolbar>
                            <IonButtons slot="start">
                                <IonMenuButton />
                            </IonButtons>
                            <IonTitle   className='headertitle' style={{ fontSize: "24"}}>Abbreviations</IonTitle>
                        </IonToolbar>
                    <IonContent fullscreen className="IonPadding">
                        <IonGrid className="paddingh20 textblack ion-padding-start ion-padding-end extra-padding ion-padding-bottom ion-margin-bottom">
                            <IonRow className="mt2  mx2 mb1 "><IonText>ACEi: Angiotensin-converting enzyme inhibitor</IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>AIIRA: Angiotensin II receptor antagonists</IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>ARNI: Angiotensin receptor neprilysin inhibitor </IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>BB: Beta blockers </IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>CKD: Chronic kidney disease </IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>DIU: Loop diuretics </IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>EF: Ejection fraction</IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>GFR: Glomerular filtration rate </IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>HF: Heart failure</IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>HR: Heart rate </IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>iSGLT2: Inhibidores del cotransportador de sodio-glucosa de tipo 2</IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>K+: Potassium</IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>LVEF: Left ventricular ejection fraction</IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>MRA: Mineralocorticoid receptors antagonists</IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>SBP: Systolic blood presssure</IonText></IonRow>
                            <IonRow className="mt2  mx2 mb1 "><IonText>SGLT2i: Sodium-glucose cotransporter 2 inhibitors</IonText></IonRow>

                        </IonGrid>
                    </IonContent>
                </IonPage>

        }</>
    );
};

export default Abrev;
